import { Users } from '@or-sdk/users';

import { useAuth } from '@/stores';

import config from '../config';

const instance = new Users({
  sdkUrl: `${config.SDK_API_URL}`,
  usersUrl: `${config.USERS_API_URL}`,
  token: () => {
    return `USER ${useAuth().reactiveToken}`;
  },
});

export default instance;
